/*
 * Staged integration for Shopify Customer Account API.
 * A Shopify app with customer_read_orders/customer_read_customers and approved
 * protected customer data must be installed before setting CLIENT_ID.
 * The empty ID keeps the live lookup invisible until it can be tested end to end.
 */
(() => {
  const CLIENT_ID = '';
  const PENDING_KEY = 'monolith-order-auth-pending';
  const RESULT_KEY = 'monolith-order-auth-result';
  const RETURN_PATH = '/pages/order-helper';
  const MAX_AGE_MS = 10 * 60 * 1000;
  const root = document.querySelector('[data-monolith-advisors]');
  const callbackPage = document.querySelector('[data-order-helper-page]');
  if (!root && !callbackPage) return;

  const language = (document.documentElement.lang || 'de').split('-')[0].toLowerCase();
  const translations = {
    de: { check:'Live-Status prüfen', invalid:'Bitte gib eine gültige Bestellnummer ein.', checking:'Wir prüfen deine Bestellung …', noMatch:'Unter diesem Kundenkonto konnten wir diese Bestellung nicht finden. Bitte nutze die Nachricht unten, dann sehen wir persönlich nach.', error:'Der Live-Status ist gerade nicht verfügbar. Bitte nutze die Bestellübersicht oder schreibe uns.', login:'Du wirst zur sicheren Shopify-Anmeldung weitergeleitet …', unfulfilled:'Noch nicht versendet', partial:'Teilweise versendet', fulfilled:'Versand vorbereitet', delivered:'Zugestellt', inTransit:'Unterwegs', outForDelivery:'In Zustellung', status:'Status', tracking:'Sendung verfolgen', ready:'Deine Bestellung wurde geprüft.', expired:'Die Anmeldung ist abgelaufen. Bitte starte die Abfrage erneut.' },
    en: { check:'Check live status', invalid:'Please enter a valid order number.', checking:'Checking your order …', noMatch:'We could not find this order in your account. Please send us a message below and we will check it personally.', error:'Live status is unavailable right now. Please check your orders or send us a message.', login:'Redirecting to secure Shopify sign-in …', unfulfilled:'Not shipped yet', partial:'Partially shipped', fulfilled:'Shipping prepared', delivered:'Delivered', inTransit:'In transit', outForDelivery:'Out for delivery', status:'Status', tracking:'Track shipment', ready:'Your order has been checked.', expired:'The sign-in has expired. Please try again.' },
    fr: { check:'Vérifier le statut', invalid:'Veuillez saisir un numéro de commande valide.', checking:'Vérification de votre commande …', noMatch:'Cette commande est introuvable dans votre compte. Envoyez-nous un message pour une vérification personnelle.', error:'Le statut en direct est indisponible. Consultez vos commandes ou écrivez-nous.', login:'Connexion sécurisée à Shopify …', unfulfilled:'Pas encore expédiée', partial:'Partiellement expédiée', fulfilled:'Expédition préparée', delivered:'Livrée', inTransit:'En cours de livraison', outForDelivery:'En livraison', status:'Statut', tracking:'Suivre le colis', ready:'Votre commande a été vérifiée.', expired:'La connexion a expiré. Veuillez réessayer.' },
    it: { check:'Controlla lo stato', invalid:'Inserisci un numero d’ordine valido.', checking:'Verifichiamo il tuo ordine …', noMatch:'Non troviamo questo ordine nel tuo account. Scrivici per una verifica personale.', error:'Lo stato in tempo reale non è disponibile. Controlla i tuoi ordini o scrivici.', login:'Accesso sicuro a Shopify …', unfulfilled:'Non ancora spedito', partial:'Spedito in parte', fulfilled:'Spedizione preparata', delivered:'Consegnato', inTransit:'In transito', outForDelivery:'In consegna', status:'Stato', tracking:'Segui la spedizione', ready:'Il tuo ordine è stato verificato.', expired:'L’accesso è scaduto. Riprova.' },
    es: { check:'Consultar estado', invalid:'Introduce un número de pedido válido.', checking:'Comprobando tu pedido …', noMatch:'No encontramos este pedido en tu cuenta. Escríbenos para revisarlo personalmente.', error:'El estado en directo no está disponible. Consulta tus pedidos o escríbenos.', login:'Acceso seguro a Shopify …', unfulfilled:'Aún no enviado', partial:'Enviado parcialmente', fulfilled:'Envío preparado', delivered:'Entregado', inTransit:'En tránsito', outForDelivery:'En reparto', status:'Estado', tracking:'Seguir envío', ready:'Hemos comprobado tu pedido.', expired:'La sesión ha caducado. Inténtalo de nuevo.' },
    pl: { check:'Sprawdź status', invalid:'Wpisz prawidłowy numer zamówienia.', checking:'Sprawdzamy zamówienie …', noMatch:'Nie znaleźliśmy tego zamówienia na Twoim koncie. Napisz do nas, a sprawdzimy je osobiście.', error:'Status na żywo jest teraz niedostępny. Sprawdź zamówienia lub napisz do nas.', login:'Bezpieczne logowanie Shopify …', unfulfilled:'Jeszcze niewysłane', partial:'Wysłane częściowo', fulfilled:'Przygotowano wysyłkę', delivered:'Dostarczone', inTransit:'W drodze', outForDelivery:'W doręczeniu', status:'Status', tracking:'Śledź przesyłkę', ready:'Sprawdziliśmy Twoje zamówienie.', expired:'Sesja wygasła. Spróbuj ponownie.' },
    sv: { check:'Kontrollera status', invalid:'Ange ett giltigt ordernummer.', checking:'Vi kontrollerar din beställning …', noMatch:'Vi hittade inte ordern på ditt konto. Skriv till oss så hjälper vi dig personligen.', error:'Livestatus är inte tillgänglig just nu. Se dina beställningar eller skriv till oss.', login:'Säker inloggning hos Shopify …', unfulfilled:'Inte skickad ännu', partial:'Delvis skickad', fulfilled:'Frakt förberedd', delivered:'Levererad', inTransit:'På väg', outForDelivery:'Ute för leverans', status:'Status', tracking:'Spåra försändelsen', ready:'Din beställning har kontrollerats.', expired:'Inloggningen har löpt ut. Försök igen.' },
    fi: { check:'Tarkista tila', invalid:'Anna kelvollinen tilausnumero.', checking:'Tarkistamme tilaustasi …', noMatch:'Tilausta ei löytynyt tililtäsi. Lähetä viesti, niin tarkistamme asian henkilökohtaisesti.', error:'Reaaliaikainen tila ei ole saatavilla. Tarkista tilauksesi tai lähetä viesti.', login:'Siirryt Shopifyn turvalliseen kirjautumiseen …', unfulfilled:'Ei vielä lähetetty', partial:'Osittain lähetetty', fulfilled:'Lähetys valmisteltu', delivered:'Toimitettu', inTransit:'Matkalla', outForDelivery:'Jakelussa', status:'Tila', tracking:'Seuraa lähetystä', ready:'Tilauksesi on tarkistettu.', expired:'Kirjautuminen vanheni. Yritä uudelleen.' },
    nl: { check:'Status controleren', invalid:'Vul een geldig bestelnummer in.', checking:'We controleren je bestelling …', noMatch:'We vonden deze bestelling niet in je account. Stuur ons een bericht; dan kijken we persoonlijk mee.', error:'De live status is nu niet beschikbaar. Bekijk je bestellingen of stuur ons een bericht.', login:'Doorsturen naar veilig inloggen bij Shopify …', unfulfilled:'Nog niet verzonden', partial:'Gedeeltelijk verzonden', fulfilled:'Verzending voorbereid', delivered:'Bezorgd', inTransit:'Onderweg', outForDelivery:'In bezorging', status:'Status', tracking:'Zending volgen', ready:'Je bestelling is gecontroleerd.', expired:'De aanmelding is verlopen. Probeer het opnieuw.' }
  };
  const t = translations[language] || translations.en;

  const randomUrl = () => {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  };
  const challengeFor = async verifier => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return btoa(String.fromCharCode(...new Uint8Array(digest))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  };
  const checkoutNumber = raw => {
    const value = String(raw || '').trim().replace(/^#/, '');
    return /^\d{4,10}$/.test(value) ? value : null;
  };
  const redirectUri = () => new URL(RETURN_PATH, location.origin).href;
  const safeLink = value => {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' ? url.href : null;
    } catch { return null; }
  };
  const readStored = key => {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
    catch { return null; }
  };

  function renderResult(target, result) {
    target.replaceChildren();
    target.hidden = false;
    const paragraph = document.createElement('p');
    if (result.kind !== 'found') {
      paragraph.textContent = t[result.kind] || t.error;
      target.append(paragraph);
      return;
    }
    const order = result.order;
    const fulfillments = order.fulfillments?.nodes || [];
    const shipment = fulfillments[0];
    const fulfillment = order.fulfillmentStatus;
    const status = fulfillment === 'PARTIALLY_FULFILLED' ? t.partial
      : fulfillments.length && fulfillments.every(f => f.latestShipmentStatus === 'DELIVERED') ? t.delivered
      : shipment?.latestShipmentStatus === 'OUT_FOR_DELIVERY' ? t.outForDelivery
      : shipment?.latestShipmentStatus === 'IN_TRANSIT' ? t.inTransit
      : fulfillment === 'FULFILLED' ? t.fulfilled
      : t.unfulfilled;
    paragraph.textContent = `${order.name} · ${t.status}: ${status}`;
    target.append(paragraph);
    const tracking = fulfillments.flatMap(f => f.trackingInformation || []).find(item => safeLink(item.url));
    const link = tracking ? safeLink(tracking.url) : safeLink(order.statusPageUrl);
    if (link) {
      const anchor = document.createElement('a');
      anchor.href = link;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.textContent = tracking ? t.tracking : t.status;
      target.append(anchor);
    }
  }

  async function start(number, result) {
    const normalized = checkoutNumber(number);
    if (!normalized) return renderResult(result, {kind:'invalid'});
    renderResult(result, {kind:'login'});
    try {
      const response = await fetch('/.well-known/openid-configuration', {credentials:'omit'});
      if (!response.ok) throw new Error('discovery');
      const config = await response.json();
      const authorizationUrl = new URL(config.authorization_endpoint);
      if (authorizationUrl.protocol !== 'https:') throw new Error('auth endpoint');
      const verifier = randomUrl();
      const state = randomUrl();
      const returnUrl = new URL(location.href);
      if (returnUrl.origin !== location.origin) throw new Error('origin');
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({verifier, state, number:normalized, returnUrl:returnUrl.href, created:Date.now()}));
      authorizationUrl.searchParams.set('scope','openid email customer-account-api:full');
      authorizationUrl.searchParams.set('client_id',CLIENT_ID);
      authorizationUrl.searchParams.set('response_type','code');
      authorizationUrl.searchParams.set('redirect_uri',redirectUri());
      authorizationUrl.searchParams.set('state',state);
      authorizationUrl.searchParams.set('code_challenge',await challengeFor(verifier));
      authorizationUrl.searchParams.set('code_challenge_method','S256');
      location.assign(authorizationUrl.href);
    } catch {
      sessionStorage.removeItem(PENDING_KEY);
      renderResult(result, {kind:'error'});
    }
  }

  async function finishCallback() {
    const message = callbackPage.querySelector('[data-order-helper-message]');
    const params = new URLSearchParams(location.search);
    if (!params.has('code') && !params.has('error')) {
      message.textContent = t.ready;
      return;
    }
    const pending = readStored(PENDING_KEY);
    sessionStorage.removeItem(PENDING_KEY);
    history.replaceState(null, '', location.pathname);
    let result = {kind:'error'};
    try {
      if (!pending || Date.now() - pending.created > MAX_AGE_MS || params.get('state') !== pending.state || !params.get('code')) throw new Error('expired');
      message.textContent = t.checking;
      const discoveryResponse = await fetch('/.well-known/openid-configuration', {credentials:'omit'});
      if (!discoveryResponse.ok) throw new Error('discovery');
      const auth = await discoveryResponse.json();
      const tokenUrl = new URL(auth.token_endpoint);
      if (tokenUrl.protocol !== 'https:') throw new Error('token endpoint');
      const body = new URLSearchParams({grant_type:'authorization_code', client_id:CLIENT_ID, redirect_uri:redirectUri(), code:params.get('code'), code_verifier:pending.verifier});
      const tokenResponse = await fetch(tokenUrl.href, {method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body, credentials:'omit'});
      if (!tokenResponse.ok) throw new Error('token');
      const {access_token: token} = await tokenResponse.json();
      if (!token) throw new Error('missing token');
      const apiResponse = await fetch('/.well-known/customer-account-api', {credentials:'omit'});
      if (!apiResponse.ok) throw new Error('api discovery');
      const api = await apiResponse.json();
      const graphqlUrl = new URL(api.graphql_api);
      if (graphqlUrl.protocol !== 'https:') throw new Error('graphql endpoint');
      const query = `query MonolithOrderStatus($search: String!) {
        customer { orders(first: 5, query: $search) { nodes {
          name fulfillmentStatus statusPageUrl
          fulfillments(first: 10) { nodes { status latestShipmentStatus trackingInformation { company number url } } }
        } } }
      }`;
      const orderResponse = await fetch(graphqlUrl.href, {method:'POST', headers:{'Content-Type':'application/json',Authorization:token}, body:JSON.stringify({query,variables:{search:`order_number:${pending.number}`}}), credentials:'omit'});
      if (!orderResponse.ok) throw new Error('order query');
      const data = await orderResponse.json();
      if (data.errors?.length) throw new Error('graphql errors');
      const order = data.data?.customer?.orders?.nodes?.find(item => item.name.replace(/^#/, '') === pending.number);
      result = order ? {kind:'found', order} : {kind:'noMatch'};
    } catch (error) {
      result = {kind:error.message === 'expired' ? 'expired' : 'error'};
    }
    sessionStorage.setItem(RESULT_KEY, JSON.stringify({result, number:pending?.number || '', created:Date.now()}));
    let returnUrl = null;
    try { if (pending?.returnUrl) returnUrl = new URL(pending.returnUrl); } catch { /* Stay on this page. */ }
    if (returnUrl?.origin === location.origin && returnUrl.pathname.startsWith('/products/')) location.replace(returnUrl.href);
    else {
      const localResult = document.createElement('div');
      message.after(localResult);
      renderResult(localResult, result);
      message.textContent = t.ready;
      sessionStorage.removeItem(RESULT_KEY);
    }
  }

  if (!CLIENT_ID) {
    if (callbackPage) callbackPage.querySelector('[data-order-helper-message]').textContent = t.error;
    return;
  }
  if (callbackPage) finishCallback();
  if (root) {
    const button = root.querySelector('[data-order-live-start]');
    const result = root.querySelector('[data-order-live-result]');
    button.hidden = false;
    button.textContent = t.check;
    button.addEventListener('click', () => start(root.querySelector('#monolith-advisor-order').value, result));
    const stored = readStored(RESULT_KEY);
    sessionStorage.removeItem(RESULT_KEY);
    if (stored && Date.now() - stored.created < MAX_AGE_MS) {
      root.querySelector('[data-advisor-open]').click();
      root.querySelector('[data-advisor-choice="order"]').click();
      root.querySelector('#monolith-advisor-order').value = stored.number;
      renderResult(result, stored.result);
    }
  }
})();

